module.exports = __webpack_public_path__ + "static/media/BlueTriangleTransition.5d649f71.svg";